import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { DashboardOutlined, FileTextOutlined, ScanOutlined, UserOutlined, InboxOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import NativeBridge from '../utils/nativeBridge';
import './MobileLayout.css';

const tabs = [
  { key: '/mobile', icon: DashboardOutlined, label: '首页' },
  { key: '/mobile/orders', icon: FileTextOutlined, label: '订单' },
  { key: '/mobile/scan', icon: ScanOutlined, label: '扫码' },
  { key: '/mobile/inventory', icon: InboxOutlined, label: '库存' },
  { key: '/mobile/profile', icon: UserOutlined, label: '我的' },
];

const shortcuts = [
  { key: '/mobile/purchases', label: '采购', color: '#fff', bg: 'rgba(255,255,255,0.25)' },
  { key: '/mobile/outbound', label: '出库', color: '#fff', bg: 'rgba(255,255,255,0.25)' },
];

export default function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // 初始化原生功能
  React.useEffect(() => {
    if (!NativeBridge.isNative()) return;
    const cleanupLongPress = NativeBridge.setupLongPressSave();
    // 监听原生toast提示
    const cleanupToast = NativeBridge.onNativeToast((msg) => {
      // 简单的toast提示
      const div = document.createElement('div');
      div.textContent = msg;
      Object.assign(div.style, {
        position: 'fixed', bottom: '100px', left: '50%', transform: 'translateX(-50%)',
        background: 'rgba(0,0,0,0.7)', color: '#fff', padding: '8px 16px', borderRadius: 20,
        fontSize: 14, zIndex: 9999, transition: 'opacity 0.3s',
      });
      document.body.appendChild(div);
      setTimeout(() => { div.style.opacity = '0'; setTimeout(() => div.remove(), 300); }, 2000);
    });
    return () => { cleanupLongPress(); cleanupToast(); };
  }, []);

  const activeKey = tabs.find(tab => {
    if (tab.key === '/mobile') return location.pathname === '/mobile';
    return location.pathname.startsWith(tab.key);
  })?.key || '/mobile';

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      background: '#f5f5f5',
      overflow: 'hidden',
    }}>
      {/* 顶部状态栏 + 标题栏（蓝色背景，占满灵动岛区域） */}
      <div className="mobile-header">
        <div className="mobile-header-row">
          <span style={{ fontSize: 16, fontWeight: 600, color: '#fff' }}>生产管理</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {shortcuts.map(s => (
              <span key={s.key}
                onClick={() => navigate(s.key, { replace: true })}
                style={{
                  padding: '2px 10px', borderRadius: 12, fontSize: 12, cursor: 'pointer',
                  color: s.color, background: s.bg, fontWeight: 500,
                }}>
                {s.label}
              </span>
            ))}
            <div style={{
              width: 28, height: 28, borderRadius: '50%', background: 'rgba(255,255,255,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: 13, fontWeight: 600,
            }}>
              {(user?.username || 'U')[0].toUpperCase()}
            </div>
            <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.9)' }}>{user?.username || ''}</span>
          </div>
        </div>
      </div>

      {/* 中间内容区 - 自适应不滚动 */}
      <div className="mobile-content">
        <Outlet />
      </div>

      {/* 底部Tab栏 */}
      <div className="mobile-tabbar">
        {tabs.map(tab => {
          const isActive = activeKey === tab.key;
          const IconComp = tab.icon;
          const isScan = tab.key === '/mobile/scan';

          if (isScan) {
            return (
              <div key={tab.key} onClick={() => navigate(tab.key, { replace: true })}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  marginTop: -16, cursor: 'pointer',
                }}>
                <div style={{
                  width: 48, height: 48, borderRadius: '50%',
                  background: isActive ? '#1677ff' : '#999',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: 22,
                  boxShadow: isActive ? '0 2px 8px rgba(22,119,255,0.4)' : 'none',
                }}>
                  <IconComp />
                </div>
                <span style={{ fontSize: 10, color: isActive ? '#1677ff' : '#999', marginTop: 2 }}>
                  {tab.label}
                </span>
              </div>
            );
          }

          return (
            <div key={tab.key} onClick={() => navigate(tab.key, { replace: true })}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
              <IconComp style={{ fontSize: 22, color: isActive ? '#1677ff' : '#999' }} />
              <span style={{ fontSize: 10, color: isActive ? '#1677ff' : '#999', marginTop: 2 }}>
                {tab.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* 底部安全区（Home指示条背景） */}
      <div className="mobile-safe-bottom" />
    </div>
  );
}
